import src from "IMAGE";
export default { src, width: 376, height: 69, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABISEmISEhJkFRUVdD07H3adlTmZb2kpaVZSH1Jwailqev0I53S2A9UAAAAASUVORK5CYII="};
